import { render } from "./AdminPagesGallery.vue?vue&type=template&id=f9ae2c80"
import script from "./AdminPagesGallery.vue?vue&type=script&lang=js"
export * from "./AdminPagesGallery.vue?vue&type=script&lang=js"

import "./AdminPagesGallery.vue?vue&type=style&index=0&id=f9ae2c80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__